import { Injectable } from '@angular/core';
import {
  defaultNavItems,
  defaultShopifyNavItems,
  INSTALLATION_FINISH_STATUS,
  navItemsPointers,
  navShopifyItemsPointers
} from '../constants';
import { NavigationState } from './navigation_state';
import { NavigationItem } from '../navigation_item';
import { Store } from '@ngrx/store';
import { PlatformType } from '../../../integrate/platform_type';
import { IAppState } from '../../../../app_state';

@Injectable()
export class NavigationStateCreator {
  private currentPlatform: PlatformType;

  constructor(private store: Store<IAppState>) {
    this.store.select(state => state.app.install.integrate).subscribe(state => {
      this.currentPlatform = state.platform;
    });
  }

  create(allData: any): NavigationState {
    let navigationItems = [];
    let isMagento2 = this.currentPlatform === PlatformType.Magento2;
    let itemsByName = {};
    let installationSettings = allData.feature ? allData.feature.InstallationV2 : {};
    if (installationSettings.step) {
      let isFinished = installationSettings.install_status === INSTALLATION_FINISH_STATUS;
      const navItems = this.currentPlatform === PlatformType.Shopify ? defaultShopifyNavItems : defaultNavItems;
      navItems.map((item) => {
        let isActive = installationSettings.step.toLowerCase() === item.url;
        let navigationItem: NavigationItem = {
          name: item.name,
          url: item.url,
          description: item.description,
          active: isActive,
          finished: false,
          skipMainIntegrationPage: isMagento2,
          isLastStep: false,
          nextStep: null,
          prevStep: null
        };
        navigationItems.push(navigationItem);
        itemsByName[navigationItem.name] = navigationItem;
      });

      navigationItems = this.setPrevNextPointers(navigationItems, itemsByName);
      navigationItems = this.setFinishedState(navigationItems, isFinished);
      return {navigationItems};
    } else {
      return null;
    }
  }

  private setPrevNextPointers(navigationSteps: Array<NavigationItem>, itemsByName: any) {

    const navItems = this.currentPlatform === PlatformType.Shopify ? navShopifyItemsPointers : navItemsPointers;
    navigationSteps.map((item) => {
      let prevItemName = navItems[item.name].prev;
      if (prevItemName) {
        item.prevStep = itemsByName[prevItemName];
      }
      let nextItemName = navItems[item.name].next;
      if (nextItemName) {
        item.nextStep = itemsByName[nextItemName];
      }

    });

    let anyActive = navigationSteps.some(ni => ni.active);
    if (!anyActive) {
      let first = navigationSteps.find(ni => !ni.prevStep);
      first.active = true;
    }
    return navigationSteps;
  }

  private setFinishedState(navigationSteps: Array<NavigationItem>, installationFinished: boolean) {
    for (let navigationStep of navigationSteps) {
      navigationStep.finished = this.isStepFinished(navigationStep, installationFinished);
    }
    return navigationSteps;
  }

  private isStepFinished(step: NavigationItem, installationFinished: boolean): boolean {
    if (installationFinished) {
      return true;
    }
    if (step.active === true) {
      return false;
    }

    let nextStep = step.nextStep;

    if (nextStep) {
      if (nextStep.active === true) {
        return true;
      }
      return this.isStepFinished(nextStep, false);
    }

    return false;
  }
}

